/**
 * Converts a decimal number into a percentage string formatted for the PT-BR locale.
 *
 * Formats numbers as percentages, rounding to two decimal places and handling positive, negative, and zero values.
 *
 * @param decimal - The decimal number to format.
 * @param minimumFractionDigits - The minimum fraction digits formatted in the percentage string. Defaults to 0.
 * @returns The formatted percentage string.
 *
 * @example
 * ```ts
 * toPercentage(0); // '0%'
 * toPercentage(0.1); // '10%'
 * toPercentage(0.12345); // '12,35%'
 * toPercentage(-0.123); // '-12,3%'
 * ```
 */
export function toPercentage(decimal: number, minimumFractionDigits: number = 0): string {
  const percentFormatter = new Intl.NumberFormat('pt-BR', {
    style: 'percent',
    maximumFractionDigits: 2,
    minimumFractionDigits
  })

  const formattedPercentage = percentFormatter.format(decimal)
  return formattedPercentage
}
